import { LocalStorageDataModel } from "../constants/local-storage-data-model";
import moment from "moment";
import { createEndmileAPITrackObject, createNewEndmileAPITrackObject, postEndmileAPIEventTrack, postNewEndmileAPIEventTrack } from "../services/eventTrack.service";
import { getDataFromLocalStorage } from "./globalUtilities";
import { ENDMILE_API_EVENT_LIST, ENDMILE_API_FIELD_ID_MAPPING_LIST } from "@Src/features/homepage/constant/endmile/newEndMileAPI.event.list";
import { ENDMILE_API_FIELD_ID_MAPPING_LIST_OLD } from "@Src/features/homepage/constant/endMileAPI.event.list";


export const triggerFreeTrailEndmileEvent = async (
    userData: any,
    endmileUtmData: any,
    email?: string
  ) => {
    const endMileUserData = localStorage.getItem(LocalStorageDataModel.ENDMILE_USER_DATA) || "[]";
    let fieldsData = userData ? userData : [...JSON.parse(endMileUserData)];
    fieldsData = [...fieldsData, ...endmileUtmData];
    fieldsData.push({
      fieldid: ENDMILE_API_FIELD_ID_MAPPING_LIST.PRODUCT_SERVICES,
      value: "Premium Free Trial",
    });
  
    const activationDate = moment().format("DD/MM/YYYY");
    const expiryDate = moment().add(7, "days").format("DD/MM/YYYY");
  
    fieldsData.push({
      fieldid: ENDMILE_API_FIELD_ID_MAPPING_LIST.ACTIVATON_DATE,
      value: activationDate,
    });
    fieldsData.push({
      fieldid: ENDMILE_API_FIELD_ID_MAPPING_LIST.EXPIRY_DATE,
      value: expiryDate,
    });
  
    let payload = await createEndmileAPITrackObject(
      ENDMILE_API_EVENT_LIST.FREE_TRIAL,
      fieldsData,
      email
    );
    postEndmileAPIEventTrack(payload);
  };

export const triggerFreeTrailNewEndmileEvent = async (
  userData: any,
  endmileUtmData: any,
  email?: string
) => {
  const endMileUserData = localStorage.getItem(LocalStorageDataModel.ENDMILE_USER_DATA) || "[]";
  let fieldsData = userData ? userData : [...JSON.parse(endMileUserData)];

  const getValue = (fieldId: string) => {
    const found = fieldsData?.find((item: any) => item.fieldid === fieldId);
    return found?.value || "";
  };

      const getArrValue = (fieldId: string) => {
    const found = fieldsData?.find((item: any) => item.fieldid === fieldId);
    let value = found?.value ? [found.value] : []
    return value;
  };

 const expiryDate = moment().add(7, 'days').format("YYYY-MM-DD");
  let newTrackData: any = {
    'FIRST_NAME_LAST_NAME': getValue(ENDMILE_API_FIELD_ID_MAPPING_LIST_OLD.FIRST_NAME_LAST_NAME),
    'PROFESSION': getValue(ENDMILE_API_FIELD_ID_MAPPING_LIST_OLD.PROFESSION),
    'DESGNATION': getArrValue(ENDMILE_API_FIELD_ID_MAPPING_LIST_OLD.DESGNATION),
    "PRODUCT_SERVICES":["Premium - Free Trial"],
    "EXPIRY_DATE": expiryDate || "",
    "PHONE_NO": getValue(ENDMILE_API_FIELD_ID_MAPPING_LIST_OLD.PHONE_NUMBER)
  };

  if (!newTrackData['STATE']) {
    newTrackData = {
      ...newTrackData,
      'STATE': getValue(ENDMILE_API_FIELD_ID_MAPPING_LIST_OLD.STATE),
    };
  }

  const areaOfSpec = getValue(ENDMILE_API_FIELD_ID_MAPPING_LIST_OLD.AREA_OF_SPECIALIZATION);
  newTrackData = {
    ...newTrackData,
    'AREA_OF_SPECIALIZATION':getValue(ENDMILE_API_FIELD_ID_MAPPING_LIST_OLD.PROFESSION) == "students" ? [] : areaOfSpec
      ? areaOfSpec.split("|").split("|").map((item:any) => item.trim())
      : [],
  };

  const city = getValue(ENDMILE_API_FIELD_ID_MAPPING_LIST_OLD.CITY);
  newTrackData = {
    ...newTrackData,
    'LOCATION': city || "",
  };

  let cidNumber: any = getDataFromLocalStorage(LocalStorageDataModel.ENDMILE_EVENTS_CID_NUMBER) || '';
  if (cidNumber?.length) {
    cidNumber = JSON.parse(cidNumber);
    newTrackData = {
      ...newTrackData,
      'CID': cidNumber?.value || "",
    };
  } else {
    newTrackData = {
      ...newTrackData,
      'CID': "",
    };
  }

  let payload = await createNewEndmileAPITrackObject(
    ENDMILE_API_EVENT_LIST.WEB_TRIAL,
    newTrackData,
    email,
   ENDMILE_API_EVENT_LIST.PREMIUM
  );
  postNewEndmileAPIEventTrack(payload);
};